import React from 'react'
import { Link } from 'react-router'

class Options extends React.Component {
  toggleOptions () {
    this.props.toggleOptions()
  }

  render () {
    return (
      <ul className='drop-down-options' onMouseLeave={this.toggleOptions.bind(this)}>
        {this.props.optionItems.map((item) => {
          return (
            <li className='item' key={item.name}>
              {(item.hasOwnProperty('action'))
                ? (
                <div onClick={() => {
                  this.toggleOptions()
                  item.action()
                }}>
                  {item.name}
                </div>
              ) : (
                <Link to={item.link}>
                  {item.name}
                </Link>
              )
              }
            </li>
          )
        })}
      </ul>
    )
  }
}

export default Options



// WEBPACK FOOTER //
// ./src/components/options.js